import { Checkbox as MUICheckbox, CheckboxProps } from '@mui/material';
import { EventType } from '@/lib/types';

export { type CheckboxProps } from '@mui/material';

export interface TrackedCheckboxProps extends CheckboxProps {
  trackChange?: (event: any) => void;
  trackEventName?: string;
  eventType?: EventType;
}

export function Checkbox({
  trackChange,
  trackEventName,
  eventType = EventType.CHECKBOX_TOGGLE,
  onChange,
  ...props
}: TrackedCheckboxProps) {
  const handleChange: CheckboxProps['onChange'] = (event, checked) => {
    if (trackChange && trackEventName) {
      trackChange({
        name: trackEventName,
        properties: {
          eventType,
          fieldName: props.name || 'Unknown Checkbox',
          checked,
        },
      });
    }
    if (onChange) {
      onChange(event, checked);
    }
  };

  return <MUICheckbox {...props} onChange={handleChange} />;
}
